<script>
export default {
  render() {
    return (
      <div class={this.$style.root}>
        {this.$slots.default &&
          this.$slots.default.map(vnode => {
            vnode.data.class = this.$style.item
            return vnode
          })}
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  display: flex;
  flex-wrap: wrap;
}

.item {
  flex: 1;
  flex-basis: 50%;

  &:not(:first-child) {
    margin-left: -1px;
  }
}
</style>
